import React from 'react';
import CopyButton, { ICopyButtonProps } from './CopyButton';

export interface ICopyAdressEmailProps extends Omit<ICopyButtonProps, 'notificationText'> {
  notificationText?: string;
}

const CopyEmailButton: React.FC<ICopyAdressEmailProps> = ({
  text = 'COPY EMAIL',
  notificationText = 'Email copied to clipboard!',
  ...otherProps
}: ICopyButtonProps) => <CopyButton text={text} notificationText={notificationText} {...otherProps} />;

export function CopyEmailButtonCircle(props: ICopyAdressEmailProps) {
  return <CopyEmailButton {...props} text={null} variant={'default-extra-light'} pill={false} circle />;
}

export default CopyEmailButton;
